<template>
    <div>
        <!-- <b-card v-show="mostrarTabela" no-body>
			<b-card-header>
				<span class="h5">Contratos</span>
			</b-card-header>
        <b-card-body>-->
        <app-tabela
            idTabela="tblResponsaveis"
            :itens="contrato.responsaveisContrato"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-inserir-responsavel
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        @obterResponsaveisAtualizados="
                            $emit('obterResponsaveisAtualizados')
                        "
                        v-if="mostrarBtnInserirResponsavel"
                    ></btn-inserir-responsavel>
                    <!-- <btn-responsaveis-padrao
                        :contrato="contrato"
                        :apostilamento="apostilamento()"
                        @obterResponsaveisAtualizados="
                            $emit('obterResponsaveisAtualizados')
                        "
                        v-if="mostrarBtnResponsaveisPadrao"
                    ></btn-responsaveis-padrao> -->
                </div>
            </template>
            <template slot="acoes" slot-scope="data">
                <!-- <span class="text-primary" v-if="mostrarBtnAtualizarResponsavel">
					<i
						class="fa fa-edit fa-lg icon-button"
						title="Atualizar"
						@click.stop="atualizarResponsavel(data.responsavelId)"
					></i>
                </span>-->
                <btn-atualizar-responsavel
                    :contrato="contrato"
                    :responsavel="data"
                    :apostilamento="apostilamento()"
                    v-if="mostrarBtnAtualizarResponsavel"
                    @obterResponsaveisAtualizados="
                        $emit('obterResponsaveisAtualizados')
                    "
                ></btn-atualizar-responsavel>
                <btn-excluir-responsavel
                    :contrato="contrato"
                    :responsavel="data"
                    :apostilamento="apostilamento()"
                    v-if="mostrarBtnExcluirResponsavel"
                    @obterResponsaveisAtualizados="
                        $emit('obterResponsaveisAtualizados')
                    "
                ></btn-excluir-responsavel>
                <!-- <span class="text-danger ml-1" v-if="mostrarBtnExcluirResponsavel">
					<i
						class="fa fa-trash fa-lg icon-button"
						title="Excluir"
						@click.stop="confirmaExcluirResponsavel(data.responsavelId)"
					></i>
                </span>-->
            </template>
        </app-tabela>
        <!-- </b-card-body>
		</b-card>
        <router-view></router-view>-->
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import BtnInserirResponsavel from './BtnInserirResponsavel'
import BtnExcluirResponsavel from './BtnExcluirResponsavel'
import BtnAtualizarResponsavel from './BtnAtualizarResponsavel'
import { situacaoContrato } from '../SituacaoContrato'
import BtnResponsaveisPadrao from './BtnResponsaveisPadrao'

export default {
    components: {
        BtnInserirResponsavel,
        BtnExcluirResponsavel,
        BtnAtualizarResponsavel,
        BtnResponsaveisPadrao
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nome',
                    label: 'Funcionário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tipoResponsavel',
                    label: 'Função',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-02') &&
                this.situacoesVigenteDistribuido()
            )
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivoContratoIniciado() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        atualizarResponsavel(responsavelId) {
            this.$router.push({
                name: 'Contratos_Responsavel_Atualizar',
                params: {
                    contratoId: this.$route.params.contratoId,
                    responsavelId: responsavelId
                }
            })
        },

        inserirResponsavel(responsavelId) {
            this.$router.push({
                name: 'Contratos_Responsavel_Inserir',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        confirmaExcluirResponsavel(responsavelId) {
            let responsavel = this.contrato.responsaveisContrato.filter(
                item => {
                    return item.responsavelId === responsavelId
                }
            )[0]
            this.$swal({
                title: 'Responsável pelo Contrato',
                html: `Confirma a exclusão do responsável ${responsavel.nome} - ${responsavel.tipoResponsavel} pelo contrato <b>${this.contrato.vcCodigoEstruturado} - ${this.contrato.fornecedor.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirResponsavel(responsavelId)
                }
            })
        },

        excluirResponsavel(responsavelId) {
            this.$store.dispatch('addRequest')
            let responsavelDto = {
                idContrato: this.contrato.idContrato,
                idResponsavelContrato: responsavelId
            }
            ContratosServicos.excluirResponsavel(responsavelDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro Excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterContratoAtualizado')
                        } else {
                            this.$toast.success(
                                'Erro ao excluir registro!',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {},

    computed: {
        mostrarBtnInserirResponsavel() {
            return (
                ((this.$temAcessoView('CONT-APOST-03') &&
                    this.situacoesVigenteDistribuido()) ||
                    (this.$temAcessoView('CONT-ELAB-00') &&
                        this.contratoElaboracao()) ||
                    (this.$temAcessoView('CONT-ADITIV-00') &&
                        this.aditivoContratoIniciado()) ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnResponsaveisPadrao() {
            return (
                ((this.$temAcessoView('CONT-APOST-03') &&
                    this.situacoesVigenteDistribuido()) ||
                    (this.$temAcessoView('CONT-ELAB-00') &&
                        this.contratoElaboracao()) ||
                    (this.$temAcessoView('CONT-ADITIV-00') &&
                        this.aditivoContratoIniciado()) ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarResponsavel() {
            return (
                ((this.$temAcessoView('CONT-APOST-03') &&
                    this.situacoesVigenteDistribuido()) ||
                    (this.$temAcessoView('CONT-ELAB-00') &&
                        this.contratoElaboracao()) ||
                    (this.$temAcessoView('CONT-ADITIV-00') &&
                        this.aditivoContratoIniciado()) ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnExcluirResponsavel() {
            return (
                ((this.$temAcessoView('CONT-APOST-03') &&
                    this.situacoesVigenteDistribuido()) ||
                    (this.$temAcessoView('CONT-ELAB-00') &&
                        this.contratoElaboracao()) ||
                    (this.$temAcessoView('CONT-ADITIV-00') &&
                        this.aditivoContratoIniciado()) ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {}
}
</script>
